import { http } from '../services';

class OrientadorService {
  async orientadorForm() {
    return http.get('/orientadores/form');
  }

  async getOrientadores(projeto) {
    return http.get('/orientadores', { projeto });
  }
}

const orientadorService = new OrientadorService();
export default orientadorService;
